<script lang="ts">
  interface RecentDuel {
    id: number;
    duel_name: string;
    end_vote: string;
    track_type: string;
    genre_name: string;
    rank: number;
    my_votes: number;
    participant_count: number;
    total_votes: number;
  }

  let { duels }: { duels: RecentDuel[] } = $props();
</script>

{#if duels.length > 0}
  <div class="section">
    <h2>Recent Duels</h2>
    <div class="table-scroll">
      <table class="data-table">
        <thead><tr><th>Duel</th><th>Genre</th><th>Type</th><th>Ended</th><th>Rank</th></tr></thead>
        <tbody>
          {#each duels as duel}
            <tr>
              <td><a href="#/duels/{duel.id}/result">{duel.duel_name}</a></td>
              <td class="muted">{duel.genre_name}</td>
              <td class="muted type-badge">{duel.track_type}</td>
              <td class="muted">{new Date(duel.end_vote).toLocaleDateString()}</td>
              <td
                class:rank-gold={duel.rank === 1}
                class:rank-silver={duel.rank === 2}
                class:rank-bronze={duel.rank === 3}
              >
                {#if duel.rank}#{duel.rank}<span class="of-count"> / {duel.participant_count}</span>{:else}&mdash;{/if}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </div>
{/if}

<style>
  .section {
    margin-top: 2rem;
  }
  .section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .table-scroll {
    overflow-x: auto;
  }
  .data-table {
    width: 100%;
    font-size: 0.875rem;
    border-collapse: collapse;
  }
  .data-table th {
    text-align: left;
    padding-bottom: 0.5rem;
    color: var(--text-muted);
    font-weight: 500;
    border-bottom: 1px solid var(--border);
  }
  .data-table td {
    padding: 0.5rem 0;
    border-bottom: 1px solid rgba(42, 42, 42, 0.5);
  }
  .data-table a {
    color: var(--cyan);
    text-decoration: none;
  }
  .data-table a:hover {
    text-decoration: underline;
  }
  .muted {
    color: var(--text-secondary);
  }
  .rank-gold {
    color: var(--gold, #ffd700);
    font-weight: 700;
  }
  .rank-silver {
    color: #c0c0c0;
    font-weight: 600;
  }
  .rank-bronze {
    color: #cd7f32;
    font-weight: 600;
  }
  .of-count {
    font-size: 0.75rem;
    color: var(--text-muted);
  }
  .type-badge {
    text-transform: capitalize;
    font-size: 0.75rem;
  }
</style>
